import { useSupportPageRedirect } from '@pages/support/model.ts';
import { Phone } from '@shared/assets/icons';
import { IconButton } from '@shared/ui';

export const ButtonSupport: React.FC = () => {
  // const { isOpen, openSupport } = useSupportModal();
  const { redirectToSupportPage } = useSupportPageRedirect();
  return (
    <IconButton
      variant={'transparent'}
      borderVariant={'square'}
      onClick={() => redirectToSupportPage()}
    >
      <Phone />
    </IconButton>
  );
};
